import React from 'react';

import { PlanningItem } from 'pages/purchasing/PlanningPage/modals/utils';

import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import { ItemLocationSettingsAuditLog } from 'components/recipes/AuditLog/ItemLocationSettingsAuditLog';

import { splitIdNameStr } from 'utils/formatting';

export function AuditLogModal({ record, onClose }: { record: PlanningItem; onClose: () => void }) {
  return (
    <Modal
      visible
      title={`Audit Log for Item #${record.item_id} at Location ${record.location}`}
      onCancel={() => onClose()}
      footer={<Button onClick={() => onClose()}>Close</Button>}
      width={900}
    >
      <ItemLocationSettingsAuditLog itemUid={record.item_uid} locationId={splitIdNameStr(record.location).foreignId} />
    </Modal>
  );
}
